/** Mobs that handle a plain right-click themselves (taming / feeding): main.ts asks `isRightClickable`. */
import type { Mob } from '../mob';
import { Wolf } from './wolf';
import { Cat } from './cat';
import { Parrot } from './jungle';

export type Clickable = Mob & { interact(held: number, rnd: () => number): { handled: boolean; consumed: boolean } };

export const isRightClickable = (m: Mob): m is Clickable => m instanceof Wolf || m instanceof Cat || m instanceof Parrot;
